import React, { useMemo } from 'react';
import { unixTimestampToDate } from '../../../../ressources/functionJS/unixTimestampToDate';
import { FloatChampInput } from '../../../../ressources/functionJS/FloatChampInput';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import DataGrid from '../../../UI/DataGrid/DataGrid';
import styles from './TableauComposante.module.scss';

const DATE_FIELDS = ['start_formula', 'end_formula'];

const ALARM_LEVELS = [
  { level: 'high4', color: 'black' },
  { level: 'high3', color: 'red' },
  { level: 'high2', color: 'amber' },
  { level: 'high1', color: 'blue' },
  { level: 'low1', color: 'blue' },
  { level: 'low2', color: 'amber' },
  { level: 'low3', color: 'red' },
  { level: 'low4', color: 'black' },
];

// Column factory
const createColumn = (field, labelKey, width = 150, formatter = null) => ({
  field,
  headerName: checkMot(labelKey),
  width,
  sortable: true,
  align: 'center',
  headerAlign: 'center',
  ...(formatter && { valueFormatter: (value) => formatter(value) }),
});

const TableauComposante = ({ component_list: propComponentList }) => {
  const columns = useMemo(
    () => [
      { ...createColumn('component_id', 'composante_id', 150), hide: true },
      createColumn('position_in_sensor', 'position_in_sensor', 150),
      createColumn('forumula', 'forumula', 200),
      createColumn('prefix', 'prefix', 120),
      createColumn('engineering_unit', 'unite', 140),
      createColumn(
        'precision_decimal_notation',
        'resolution_decimales',
        160,
        FloatChampInput
      ),
      ...DATE_FIELDS.map((field) =>
        createColumn(field, field, 180, unixTimestampToDate)
      ),
      createColumn('calibration_factors', 'calibration_factors', 160),
      createColumn('y_scale', 'y_scale', 120),
      createColumn('time_period', 'time_period', 130),
      createColumn('measures_num', 'measures_num', 140),
      createColumn('serial_number', 'serial_number', 140),
      createColumn('coordinate_x', 'coordinate_x', 130),
      createColumn('coordinate_y', 'coordinate_y', 130),
      createColumn('coordinate_z', 'coordinate_z', 130),
      ...ALARM_LEVELS.map(({ level, color }) =>
        createColumn(`alarmlevel_${level}`, `alarmlevel_${level}_${color}`, 150)
      ),
      createColumn('time_refresh', 'time_refresh', 130),
    ],
    []
  );

  return (
    <div className={styles.container}>
      <DataGrid
        rows={propComponentList || []}
        columns={columns}
        getRowId={(row) => row.component_id}
        pageSizeOptions={[10, 25, 50]}
        initialPageSize={10}
        disableRowSelectionOnClick
        autoHeight
      />
    </div>
  );
};

export default TableauComposante;
